<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<myprofile-signup-ui-notification-banner
  class="absolute z-501"
  [isOpen]="openBanner"
  [state]="'error'"
  [message]="'signup.activateAccount.tooManySmsSentError.description'"
  (dismissed)="closeBanner()"
>
</myprofile-signup-ui-notification-banner>
@if (mode === RegistrationProcess.OWNER) {
  <div>
    @if (transactionType$ | async; as transactionType) {
      <div class="w-full">
        <p-text
          [size]="{ base: 'sm', m: 'md' }"
          class="mt-fluid-sm sm:mt-fluid-md text-balance"
          [innerHTML]="'signup.activateAccount.confirmationCode.sentHint' | translate: { MASKED_MOBILE_NO: mobile }"
        ></p-text>
        @if (
          transactionType === TransactionType.SIMPLIFIED_ADD_NON_CONNECT_VEHICLE ||
          transactionType === TransactionType.SIMPLIFIED_ADD_CONNECT_VEHICLE
        ) {
          <p-text [size]="{ base: 'sm', m: 'md' }" class="md:mt-fluid-sm">
            <span class="md:me-static-xs" [innerText]="'signup.simplifiedAddVehicle.confirmation.incorrectNumber.text' | translate"></span>
            <span class="md:me-static-xs">
              <p-button-pure
                type="button"
                [underline]="true"
                [icon]="'none'"
                data-e2e="simpliefied-add-vehicle-go-to-manual-process"
                [myprofileSignupUiTrack]="{
                  clickElementType: 'button',
                  clickElementId: 'linkout',
                  clickElementName: 'link_to_external-target',
                  pageName: currentPageName,
                  eventAction: 'PAGMyPorsche_SignUpIdentityRequest_Click',
                }"
                (click)="goToManualAddVehicleProcess()"
              >
                {{ 'signup.simplifiedAddVehicle.confirmation.incorrectNumber.link.text' | translate }}
              </p-button-pure>
            </span>
          </p-text>
        }
        <form
          [formGroup]="formGroup"
          myprofileSignupUiValidationTrack="verificationCodeForm"
          class="mt-fluid-lg md:mt-fluid-md"
          data-e2e="confirmation-confirmIdentity-form"
        >
          <p-pin-code
            [name]="'sms-code-owner'"
            [length]="otpLength"
            (change)="onAutoSubmitOTP($event, mode)"
            [loading]="
              (codeStatus$ | async) === ConfirmationCodeStatus.CODE_STATUS_VALIDATION_PENDING ||
              (codeStatus$ | async) === ConfirmationCodeStatus.CODE_STATUS_VALID
            "
            [state]="messageState"
            [message]="messages[0]"
            data-e2e="sms-code-owner"
            #smsCodeOwner
          >
            <span slot="label" id="pin-code" class="md:text-md">
              {{ 'signup.activateAccount.confirmationCode.enterHint.label' | translate }}
            </span>
          </p-pin-code>
          <div class="flex flex-col mt-fluid-lg md:mt-fluid-md">
            <p-text [size]="{ base: 'sm', m: 'md' }" class="me-static-xs inline-block">
              <span [innerText]="'signup.activateAccount.confirmationCode.notReceived.label' | translate"></span>
            </p-text>
            <myprofile-signup-ui-timer-label
              [requestCodeTimerLabel]="'signup.activateAccount.confirmationCode.requestNewCode.button.label' | translate"
              [waitingTimerLabelText]="'pida.activateAccount.confirmationCode.requestConfirmationCodeWaiting' | translate"
              [inactiveTimerButton]="
                !!((otpRequested$ | async) || isCodeStatusPendingOrValid(codeStatus$ | async) || (otpRequestedBlocked$ | async))
              "
              (clickedTimerEvent)="onRequestOTP(true)"
              [myprofileSignupUiTrack]="{
                clickElementType: 'button',
                clickElementId: 'activation_code',
                clickElementName: 'resend_code',
                pageName: currentPageName,
                eventAction: 'PAGMyPorsche_SignUpIdentityRequest_Click',
              }"
            ></myprofile-signup-ui-timer-label>
          </div>
        </form>
      </div>
    }
  </div>
}
@if (mode === RegistrationProcess.PROSPECT) {
  <div>
    <p-text class="mt-fluid-lg" [innerHTML]="'signup.register.prospect.verifySms.subline.label' | translate: { mobile: mobile }"></p-text>
    <form
      [formGroup]="formGroup"
      myprofileSignupUiValidationTrack="verificationCodeForm"
      class="mt-fluid-lg"
      data-e2e="confirmation-confirmIdentity-form"
    >
      <p-pin-code
        [label]="'signup.register.prospect.verifySms.input.label' | translate"
        [name]="'sms-code-prospect'"
        [length]="otpLength"
        (change)="onAutoSubmitOTP($event, mode)"
        [loading]="
          codeStatus === ConfirmationCodeStatus.CODE_STATUS_VALIDATION_PENDING || codeStatus === ConfirmationCodeStatus.CODE_STATUS_VALID
        "
        [state]="messageState"
        [message]="messages[0]"
        data-e2e="sms-code-prospect"
        #smsCodeProspect
      ></p-pin-code>
      <div class="mt-fluid-lg">
        <p-text size="sm" class="me-static-xs inline-block">
          <span [innerText]="'signup.register.prospect.verifySms.body.label' | translate"></span>
        </p-text>
        <myprofile-signup-ui-timer-label
          [requestCodeTimerLabel]="'signup.activateAccount.confirmationCode.requestNewCode.button.label' | translate"
          [waitingTimerLabelText]="'pida.activateAccount.confirmationCode.requestConfirmationCodeWaiting' | translate"
          [inactiveTimerButton]="otpRequested"
          (clickedTimerEvent)="onRequestProspectOTP()"
          [myprofileSignupUiTrack]="{
            clickElementType: 'button',
            clickElementId: 'activation_code',
            clickElementName: 'resend_code',
            pageName: currentPageName,
            eventAction: 'PAGMyPorsche_SignUpIdentityRequest_Click',
          }"
        ></myprofile-signup-ui-timer-label>
      </div>
    </form>
  </div>
}
